'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uxcore = require('@ux/uxcore2');

var defaultSplit = 'A'; /* eslint
                          no-param-reassign:
                            ["error", { "props": true, "ignorePropertyModificationsFor": ["window"] }]
                          no-underscore-dangle:
                            ["error", { "allow": ["_trfq"] }]
                        */
// Cookie Reference for values: https://confluence.godaddy.com/pages/viewpage.action?spaceKey=CKPT&title=Cookies+Used+and+Created

var defaultTmsSplit = 'chat-split-A';
var getCookie = function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length === 2) {
    return parts[1].split(';').shift();
  }
};

var getVisitorGuId = function getVisitorGuId() {
  var visitor = getCookie('visitor');
  if (visitor && visitor.length > 4) {
    return visitor.split('=')[1];
  }
};

/**
 * This configures lpTag (Live Person Tag), with additional chat metadata specific to GoDaddy.
 *
 * @param {Object} window The Javascript Window
 * @param {string} productId Product Id the user is viewing
 * @param {Object} utag User Tag
 * @param {function} callback Calls back when complete
 * @private
 */
var configureTag = function configureTag(window, productId, utag, callback) {
  window.lpTag = window.lpTag || {};

  var lpTag = window.lpTag;
  lpTag.sdes = lpTag.sdes || [];
  lpTag.section = lpTag.section || [];

  var section = lpTag.section;

  var location = window.location;
  if (location) {
    if (location.hostname) {
      var hostnameParts = location.hostname.split('.');
      var env = 'prod';
      if (hostnameParts.length >= 2) {
        var sld = hostnameParts[hostnameParts.length - 2];
        var sldParts = sld.split('-');
        if (sldParts.length >= 2) {
          env = sldParts[0];
        }
      }
      section.push('env:' + env);
      if (hostnameParts.length >= 3) {
        var subdomain = hostnameParts[hostnameParts.length - 3];
        section.push('subdomain:' + subdomain);
      }
    }
    if (!location.pathname || location.pathname === '' || location.pathname === '/') {
      section.push('home');
    }
    section.push('path:' + location.pathname);
    if (location.pathname) {
      var paths = location.pathname.split('/');
      if (paths.length >= 2) {
        var context = paths[1];
        if (context) {
          section.push(context);
        }
      }
    }
    if (/\bCHAT_ENABLE=(true|1)\b/i.test(location.search)) {
      section.push('chat_enable');
    }
  }

  if (utag) {
    if (utag['cp.market']) {
      section.push('market:' + utag['cp.market']);
      var market = utag['cp.market'].split('-');
      if (market.length === 2) {
        section.push('lang:' + market[0]);
      }
    }
    if (utag.app_name) {
      section.push('app:' + utag.app_name);
    }
    if (utag.pl_id) {
      section.push('plid:' + utag.pl_id);
      section.push('isgd:' + (utag.pl_id === 1));
    }
  }

  var customerInfoSde = {
    type: 'ctmrinfo',
    info: {}
  };

  var infoIdp = _uxcore.utils.cookie.get('info_idp');
  var shopper = infoIdp && JSON.parse(infoIdp);

  customerInfoSde.info.userName = getVisitorGuId() || '';
  customerInfoSde.info.accountName = _uxcore.utils.cookie.get('pathway') || '';
  customerInfoSde.info.ctype = productId || '';

  if (shopper) {
    customerInfoSde.info.customerId = shopper.info_shopperId || '';
    lpTag.sdes.push({
      type: 'personal',
      personal: {
        firstname: shopper.firstname,
        lastname: shopper.lastname
      }
    });
  }

  lpTag.sdes.push(customerInfoSde);

  window._trfq = window._trfq || [];
  var trfq = window._trfq;
  trfq.push(['cmdGetTrackingValues', function (traffic) {
    var trafficId = traffic.vtg + '|' + traffic.vg;
    lpTag.sdes.push({
      type: 'ctmrinfo',
      info: {
        socialId: trafficId
      }
    });
  }]);

  var gdChat = window.gdchat;
  if (gdChat) {
    if (gdChat.managedLevel) {
      section.push('managedLevel:' + gdChat.managedLevel);
    }
    if (gdChat.vars) {
      Object.keys(gdChat.vars).forEach(function (key) {
        section.push(key + ':' + gdChat.vars[key]);
      });
    }
  }

  var ux = window.ux;
  if (ux && ux.eldorado && ux.eldorado.shopperData) {
    var timerId = setTimeout(function () {
      section.push('split:' + defaultSplit);
      callback(new Error('Timed out waiting for shopperData, defaulting to split:' + defaultSplit));
    }, 5000);
    ux.eldorado.shopperData(function (err, data) {
      clearTimeout(timerId);
      var split = data && data.chat_split || defaultSplit;
      section.push('split:' + split);
      var tmsSplit = defaultTmsSplit;
      if (data && data.tms) {
        for (var i = 0; i !== data.tms.length; i += 1) {
          var tms = data.tms[i];
          if (tms.Strategy === 'chat_split') {
            tmsSplit = tms.Name;
            break;
          }
        }
      }
      section.push('tms_split:' + tmsSplit);
      setImmediate(function () {
        callback(err);
      });
    });
  } else {
    section.push('split:' + defaultSplit);
    section.push('tms_split:' + defaultTmsSplit);
    setImmediate(callback);
  }
};

exports.default = configureTag;